const data: any = [{"key":"looking-for-canceled","copy":"Looking for canceled or expired cards?"},{"key":"history","copy":"View History"}];
export default data